import { type ReactNode } from "react";
import { Container } from "@/components/ui/Container";
import { BackgroundGrid } from "@/components/layout/BackgroundGrid";
import { MotionWrapper } from "@/components/ui/MotionWrapper";

export function PageHero({
  eyebrow,
  title,
  description,
  actions,
}: {
  eyebrow?: string;
  title: string;
  description?: string;
  actions?: ReactNode;
}) {
  return (
    <section className="relative overflow-hidden border-b border-line py-16 sm:py-24">
      <BackgroundGrid />
      <Container className="relative">
        <MotionWrapper className="max-w-3xl">
          {eyebrow && (
            <p className="mb-3 font-mono text-xs uppercase tracking-[0.12em] text-accent-lime">
              {eyebrow}
            </p>
          )}
          <h1 className="text-3xl font-bold uppercase leading-tight tracking-tight text-text-primary sm:text-4xl lg:text-5xl">
            {title}
          </h1>
          {description && (
            <p className="mt-5 text-base text-text-secondary sm:text-lg">{description}</p>
          )}
          {actions && <div className="mt-8 flex flex-wrap gap-4">{actions}</div>}
        </MotionWrapper>
      </Container>
    </section>
  );
}
